<template>
  <section class="offer">
    <select-box @action="setHasQuote" :selected="hasQuote"></select-box
    ><span class="pointer" @click="setHasQuote"
      >Order n.a.v. offerteaanvraag</span
    >
    <input
      v-show="hasQuote"
      class="grey-field"
      :class="{ invalid: quoteNo.length < 9 }"
      type="text"
      placeholder="Uw offertenummer"
      :value="quoteNo"
      @input="updateQuote"
      maxlength="9"
    />
  </section>
</template>

<script>
export default {
  props: ['quoteNo'],
  data() {
    return {
      hasQuote: false
    }
  },
  methods: {
    setHasQuote() {
      this.$emit('set-quote', '')
      if (this.hasQuote) {
        this.hasQuote = false
        //EventBus.emit('removeError', 'quoteError')
      } else {
        this.hasQuote = true
        //EventBus.emit('addError', 'quoteError')
      }
    },
    updateQuote(e) {
      this.$emit('set-quote', e.target.value)
      /* if (e.target.value.length === 7) {
        EventBus.emit('removeError', 'quoteError')
      } else {
        EventBus.emit('addError', 'quoteError')
      } */
    }
  },
  created() {
    if (this.quoteNo.length > 0) {
      this.hasQuote = true
    }
  }
}
</script>

<style lang="scss" scoped>
.offer {
  height: 59px;
}
input {
  margin: 0px 0 0 10px;
  width: 163px;
}
</style>
